import * as modalActionsType from '@/constants/modalActionsType';

/**
 * Show numpad keyboard
 * @param modalHeader : modal title header and parameter type on callback function
 * @param value
 * @param maxDigitAfterDecimal
 * @param incrementValue
 * @param minValue
 * @param maxValue
 * @param unit : APPDATA.UNIT
 * @method callback : callback Func
 * @method validatorInput : validator Func
 * @param {(FmlxNumpad.mode.normal|FmlxNumpad.mode.password)} numpadMode : FmlxNumpad.mode.password / normal
 * @param info : additional warning message
 */
export function showModal(value) {
  return {
    type: modalActionsType.SHOW_MODAL,
    value,
  };
}

/**
 * Hide numpad keyboard (no param)
 */
export function hideModal() {
  return {
    type: modalActionsType.HIDE_MODAL,
  };
}

/**
 * Pop up message
 * @param popUpTitle : popUp title header,
 * @param popUpText : detail text of popup
 * @param popUpQuestion : popup question
 * @param popUpButton : popup buttton
 * @method popUpClose : popup onClose callback
 * @param popUpHideCloseButton : hide/show popup X buttton
 */
export function showPopUp(value) {
  return {
    type: modalActionsType.SHOW_POPUP,
    value,
  };
}

/**
 * Hide Pop up (no param)
 */
export function hidePopUp() {
  return {
    type: modalActionsType.HIDE_POPUP,
  };
}

/**
 *
 * @param {(true|false)} loadSetupVisible : hide/show load setup component
 */
export function showLoadSetup(value) {
  return {
    type: modalActionsType.SHOW_LOADSETUP,
    value,
  };
}

/**
 * Keyboard Component
 * @param {*} keyboardValue : value for input keyboard
 * @param {*} keyboardTitle : title of keyboard numpad
 * @method keyboardCallBack : call back action after press OK
 * @param keyboardPlaceholder
 * @param overwriteFirstInput : overide the value
 * @param max : max Char input
 *
 */
export function showKeyboard(value) {
  return {
    type: modalActionsType.SHOW_KEYBOARD,
    value,
  };
}

/**
 * Hide Pop up (no param)
 */
export function hideKeyboard() {
  return {
    type: modalActionsType.HIDE_KEYBOARD,
  };
}

export function showHardwareCheckup(value) {
  return {
    type: modalActionsType.SHOW_HARDWARE_CHECKUP,
    value,
  };
}
export function updateHardwareCheckUpButton(value) {
  return {
    type: modalActionsType.UPDATE_HARDWARE_CHECK_UP_BUTTON,
    value,
  };
}
export function runHardwareCheckUp(value) {
  return {
    type: modalActionsType.RUN_HARDWARE_CHECK_UP,
    value,
  };
}

export function pausedHardwareCheckUp(value) {
  return {
    type: modalActionsType.PAUSED_HARDWARE_CHECK_UP,
    value,
  };
}
export function updateHardwareList(value) {
  return {
    type: modalActionsType.UPDATE_HARDWARE_LIST,
    value,
  };
}
export function updatehardwareCheckupState(value) {
  return {
    type: modalActionsType.UPDATE_HARDWARE_CHECK_UP_STATE,
    value,
  };
}
